import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Plus, UserPlus, CreditCard } from 'lucide-react';

const VolunteersPage = () => {
  return (
    <div>
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800 dark:text-white">Volunteer Management</h1>
        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
          Manage your volunteers and their activities
        </p>
      </div>



      {/* Actions Bar */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 mb-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-center gap-4">
            <h2 className="text-lg font-semibold text-gray-800 dark:text-white">
              Volunteers Overview
            </h2>
          </div>
          
          {/* Add Volunteer Button */}
          <Link
            to="/ngo/dashboard/volunteers/add"
            className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200"
          >
            <UserPlus className="mr-2" size={20} />
            Add Volunteer
          </Link>
        </div>
      </div>

      {/* Content Placeholder */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-8 text-center">
        <Users className="mx-auto h-16 w-16 text-gray-400 mb-4" />
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
          Volunteer Management System
        </h3>
        <p className="text-gray-500 dark:text-gray-400 mb-6">
          This is a placeholder for the volunteer management system.
        </p>
        
        <div className="flex justify-center gap-4">
          <Link
            to="/ngo/dashboard/volunteers/add"
            className="inline-flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors duration-200"
          >
            <Plus className="mr-2" size={20} />
            Add New Volunteer
          </Link>
          
          <Link
            to="/ngo/dashboard/volunteers/manage"
            className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200"
          >
            <Users className="mr-2" size={20} />
            Manage Volunteers
          </Link>

          <Link
            to="/ngo/dashboard/volunteers/id-card-demo"
            className="inline-flex items-center px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors duration-200"
          >
            <CreditCard className="mr-2" size={20} />
            View ID Card Demo
          </Link>
        </div>
      </div>
    </div>
  );
};

export default VolunteersPage;
